import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Global UX: select all text when a number input receives focus,
// so the user can type immediately without manually clearing the existing value.
document.addEventListener('focus', (e) => {
  if (e.target.type === 'number') {
    e.target.select();
  }
}, true /* capture phase - fires before React synthetic events */);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
